/**
 * Words a display name may not contain, for `displayName.ts`. A first line, not moderation.
 *
 * Matched as SUBSTRINGS of a squashed form of the name (lower-case, accents and leet undone,
 * everything but a–z removed), so `F.u_c-k` and `5h1t` are caught. That also means every entry
 * here bans every name containing it, which is why the list stays short and avoids anything that
 * lives inside ordinary names: no `ass` (Cassandra), `cock` (Hancock), `dick` (Dickens), `rape`
 * (Grapes), `spic` (Spice), `tit` (Titus). Add a word only after checking what it would catch.
 */
export const BLOCKED_NAME_PARTS = [
    'fuck',
    'shit',
    'cunt',
    'bitch',
    'whore',
    'slut',
    'twat',
    'wank',
    'pussy',
    'dildo',
    'penis',
    'vagina',
    'porn',
    'nigger',
    'nigga',
    'faggot',
    'retard',
    'kike',
    'nazi',
    'hitler',
];
//# sourceMappingURL=displayNameBlocklist.js.map